import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../src/Css/Responsive.css";
import "../src/Css/Style.css";
import Comingsoon from "./Components/Comingsoon";
import ChangePassword from "./Components/Common/ChangePassword";
import ForgetPassword from "./Components/Common/ForgetPassword";
import ResetPassword from "./Components/Common/ResetPassword";
import VerifyOTP from "./Components/Common/VerifyOTP";
import Home from "./Components/Home";
import Layout from "./Components/Layout/Layout";
import Login from "./Components/Login";
import Notfound from "./Components/Notfound";

function App() {
  const state = useSelector((state) => state);
  return (
    <BrowserRouter>
      <Routes>
        <Route
          exact
          path="/Login"
          element={
            !state?.auth?.isLoggedIn ? (
              <Login />
            ) : (
              <Navigate replace to="/app/dashboard" />
            )
          }
        />
        <Route path="*" element={<Notfound />} />
        <Route exact path="/" element={<Home />} />
        <Route exact path="/ChangePassword" element={<ChangePassword />} />
        <Route exact path="/ForgetPassword" element={<ForgetPassword />} />
        <Route exact path="/VerifyOTP" element={<VerifyOTP />} />
        <Route exact path="/ResetPassword" element={<ResetPassword />} />
        <Route exact path="/Comingsoon" element={<Comingsoon />} />
        <Route exact path="/app/*" element={<Layout />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
